//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    headers: Array,
    registros: Array,
  },
  watch: {
    registros() {
      this.$forceUpdate();
    },
  },
  methods: {
    alterandoValor(props) {
      const { log } = console;
      log('estou aqui');
      log(props);
      return this.$t(`errors.importacao.${props.item.descricao.toLowerCase()}`,
        { param: props.item.param });
    },
  },
  mounted() {
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/importacao/ImportacaoErroTabela.vue?vue&type=script&lang=js&